import {Route} from "react-router-dom";
import React from "react";
import {Routes} from "react-router";
import {Billing} from "./Billing";
import {Payments} from "./Payments";
import {PaymentDetails} from "./PaymentDetails";

export const BillingRouter = () => {

  return <Routes>
    <Route path={'/'} element={<Billing/>}/>
    <Route path={'/payments'} element={<Payments/>}/>
    <Route path={'/payments/:paymentId'} element={<PaymentDetails/>}/>
  </Routes>
}
